import React, { useEffect, useState } from 'react';
import { Button } from './Button';
import { Menu, X } from 'lucide-react';
export function NavBar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-161">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        <div className="flex justify-between items-center" data-id="element-163">
          <div className="flex items-center" data-id="element-164">
            <a href="#" className="text-2xl font-bold font-['Plus_Jakarta_Sans'] tracking-tight" data-id="element-165">
              <span style={{
              color: '#0F172A'
            }} className="font-[700] font-[Inter,_sans-serif]" data-id="element-166">
                Pen
              </span>
              <span style={{
              color: '#059669'
            }} className="font-[Inter,_sans-serif]" data-id="element-167">
                Point
              </span>
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-168">
            <a href="#problem" className="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-id="element-169">
              Problems
            </a>
            <a href="#approach" className="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-id="element-170">
              Approach
            </a>
            <a href="#services" className="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-id="element-171">
              Services
            </a>
            <a href="#results" className="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-id="element-172">
              Results
            </a>
            <Button variant="primary" size="sm" onClick={() => {
            if (typeof window !== 'undefined' && (window as any).Calendly) {
              ;
              (window as any).Calendly.initPopupWidget({
                url: 'https://calendly.com/okechcopy/new-meeting'
              });
            }
          }} data-id="element-173">
              Book Strategy Call
            </Button>
          </div>

          <div className="md:hidden" data-id="element-174">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-900 p-2" data-id="element-175">
              {isMobileMenuOpen ? <X size={24} data-id="element-176" /> : <Menu size={24} data-id="element-177" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-slate-100 p-4 shadow-lg animate-in slide-in-from-top-5" data-id="element-178">
          <div className="flex flex-col space-y-4" data-id="element-179">
            <a href="#problem" className="text-slate-600 font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-180">
              Problems
            </a>
            <a href="#approach" className="text-slate-600 font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-181">
              Approach
            </a>
            <a href="#services" className="text-slate-600 font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-182">
              Services
            </a>
            <a href="#results" className="text-slate-600 font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-183">
              Results
            </a>
            <Button className="w-full" onClick={() => {
          setIsMobileMenuOpen(false);
          if (typeof window !== 'undefined' && (window as any).Calendly) {
            ;
            (window as any).Calendly.initPopupWidget({
              url: 'https://calendly.com/okechcopy/new-meeting'
            });
          }
        }} data-id="element-184">
              Book Strategy Call
            </Button>
          </div>
        </div>}
    </nav>;
}